import React from 'react';
import './styles.scss';
import config from 'config';
import { IEventsListItem } from './interface';

function EventsListItem({ event }: IEventsListItem) {
    return (
        <div className='events-list-item'>
            <img
                src={`${config.API_URL}/events/images/${event.Id}`}
                alt='Item Img'
            />
            <p className='events-list-item__title'>
                {event.Eventlanguages[0].Name}
            </p>
            <p className='events-list-item__description'>
                {event.Eventlanguages[0].Description}
            </p>
        </div>
    );
}

export default EventsListItem;
